import { Flex, FlexChild, Typography, TextColors, FontFamilies } from "@abel-technologies-as/components";
import { ModalIconWrapper } from "./style";
import { ModalPartProps } from "./ModalPart.types";

export const ModalHeader = ({ subTitle, title, icon }: ModalPartProps) => {
	return (
		<>
			<Flex gap="16px" justifyContent="flex-start" margin="0 0 10px 0">
				{icon && <ModalIconWrapper>{icon}</ModalIconWrapper>}
				<Flex justifyContent="flex-start">
					<FlexChild>
						<Typography
							fontFamily={FontFamilies.InterSemiBold}
							color={TextColors.Primary}
							fontWeight={600}
							fontSize="18px"
							lineHeight="28px"
							variant="h1">
							{title}
						</Typography>
						<Typography
							color={TextColors.Tertiary}
							fontWeight={400}
							lineHeight="20px"
							fontSize="14px"
							fontFamily={FontFamilies.InterRegular}
							variant="h3">
							{subTitle}
						</Typography>
					</FlexChild>
				</Flex>
			</Flex>
		</>
	);
};
